import Model from "./Model";

export { Model };